module.exports = "<div class=\"image-box js-swipe-load\" style=\"background-image: url('<%-item.small%>');\">\r\n    <a class=\"image-box__link <%-item.linkToSection ? '' : 'js-zoom-slider'%>\"\r\n       <% if (item.linkToSection) { %>data-link-to-section=\"<%-item.linkToSection%>\" <% } %>\r\n       href=\"<%-item.linkToSection ? item.linkToSection : item.big %>\"\r\n       data-slide-number=\"<%-item.index%>\">\r\n        <h3 class=\"image-box__title\"><%-item.title%><svg class=\"icon\"><use xlink:href=\"#spr-right\"></use></svg></h3>\r\n    </a>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./js/components/Gallery/GalleryItemImage.ejs
// module id = 228
// module chunks = 0